import { isCnpj, isCpf, isMaskedCnpj, isMaskedCpf } from './pixValidations';
export const formatPhoneNumber = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length === 0) {
        return '';
    }
    if (numbers.length <= 2) {
        return `(${numbers}`;
    }
    if (numbers.length <= 6) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }
    if (numbers.length <= 10) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
    }
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
};
export const unformatValue = (value) => {
    return value.replace(/\D/g, '');
};
export const formatAsRandomPixKey = (value) => {
    if (!value)
        return '';
    const cleanValue = value.replace(/[^0-9a-fA-F]/g, '');
    let newValue = cleanValue;
    if (cleanValue.length > 8) {
        newValue = `${newValue.slice(0, 8)}-${newValue.slice(8)}`;
    }
    if (cleanValue.length > 12) {
        newValue = `${newValue.slice(0, 13)}-${newValue.slice(13)}`;
    }
    if (cleanValue.length > 16) {
        newValue = `${newValue.slice(0, 18)}-${newValue.slice(18)}`;
    }
    if (cleanValue.length > 20) {
        newValue = `${newValue.slice(0, 23)}-${newValue.slice(23)}`;
    }
    if (cleanValue.length > 36) {
        newValue = newValue.slice(0, 36);
    }
    return newValue;
};
export const formatAsBankAccountWithDigit = (value) => {
    if (!value)
        return '';
    let cleanValue = value.replace(/[^0-9Xx]/g, '');
    cleanValue = cleanValue.replace(/x/g, 'X');
    if (cleanValue.length === 0) {
        return '';
    }
    if (cleanValue.includes('X')) {
        const lastChar = cleanValue.slice(-1);
        const accountNumber = cleanValue.slice(0, -1);
        if (lastChar === 'X') {
            return accountNumber.length > 0 ? `${accountNumber}-X` : 'X';
        }
        const cleanAccountNumber = cleanValue.replace(/X/g, '');
        if (cleanAccountNumber.length === 0) {
            return '';
        }
        if (cleanAccountNumber.length === 1) {
            return cleanAccountNumber;
        }
        const account = cleanAccountNumber.slice(0, -1);
        const digit = cleanAccountNumber.slice(-1);
        return `${account}-${digit}`;
    }
    if (cleanValue.length === 1) {
        return cleanValue;
    }
    const accountNumber = cleanValue.slice(0, -1);
    const digit = cleanValue.slice(-1);
    return `${accountNumber}-${digit}`;
};
export const removeFormatOfRandomPixKey = (value) => {
    if (!value)
        return;
    return value.replace(/-/g, '');
};
export const formatAsOnlyNumbers = (value) => {
    if (!value)
        return;
    return value.replace(/\D/g, '');
};
export const maskIdentificationNumber = (value) => {
    if (isMaskedCnpj(value)) {
        return `**.${value.substring(2, 5)}.${value.substring(5, 8)}/****-**`;
    }
    if (isMaskedCpf(value)) {
        return `***.${value.substring(3, 6)}.${value.substring(6, 9)}-**`;
    }
    const onlyDigits = value.replace(/\D/g, '');
    if (isCnpj(value)) {
        return `**.${onlyDigits.substring(2, 5)}.${onlyDigits.substring(5, 8)}/****-**`;
    }
    if (isCpf(value)) {
        return `***.${onlyDigits.substring(3, 6)}.${onlyDigits.substring(6, 9)}-**`;
    }
};
export const formatIdentificationNumber = (value) => {
    if (!value)
        return;
    const onlyDigits = value.replace(/\D/g, '');
    if (isCnpj(value)) {
        return onlyDigits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    if (isCpf(value)) {
        return onlyDigits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
};
export const formatIdentificationNumberAlphanumeric = (value, helpers) => {
    if (!value)
        return;
    if (helpers.isValidCnpj(value)) {
        return helpers.maskCnpj(value);
    }
    if (isCpf(value)) {
        const onlyDigits = value.replace(/\D/g, '');
        return onlyDigits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
};
export const maskIdentificationNumberAlphanumeric = (value, helpers) => {
    if (isMaskedCnpj(value) || isMaskedCpf(value))
        return value;
    if (isCpf(value)) {
        const onlyDigits = value.replace(/\D/g, '');
        return `***.${onlyDigits.substring(3, 6)}.${onlyDigits.substring(6, 9)}-**`;
    }
    if (helpers.isValidCnpj(value)) {
        const canonical = helpers.unmaskCnpj(value);
        return `**.${canonical.substring(2, 5)}.${canonical.substring(5, 8)}/****-**`;
    }
};
export const removeRegionalPhoneCode = (value) => {
    if (!value)
        return value;
    return value.startsWith('+55') ? value.slice(3) : value;
};
export const formatAsRegionalPhoneCode = (value) => {
    if (!value || typeof value !== 'string')
        return '';
    const digits = value.replace(/\D/g, '');
    if (value.startsWith('+55')) {
        return `+55${digits.slice(2)}`;
    }
    return `+55${digits}`;
};
